import { combineReducers } from "redux";
import {
  _FAILURE,
  _SUCCESS,
  FETCH_CO_OPERATION_OLD_REQUEST,
  UPDATE_CO_OPERATIONS_STATUS_OLD_REQUEST,
} from "./constants";

function item(state = {}, action) {
  switch (action.type) {
    case FETCH_CO_OPERATION_OLD_REQUEST + _SUCCESS:
      return action.payload;

    case UPDATE_CO_OPERATIONS_STATUS_OLD_REQUEST + _SUCCESS:
      return {
        ...state,
        status: state.id === action.payload.id ? action.payload.status : state.status,
      };

    case UPDATE_CO_OPERATIONS_STATUS_OLD_REQUEST + _FAILURE:
      return {
        ...state,
      };

    default:
      return state;
  }
}

function isFetching(state = false, action) {
  switch (action.type) {
    case FETCH_CO_OPERATION_OLD_REQUEST:
      return true;
    case FETCH_CO_OPERATION_OLD_REQUEST + _SUCCESS:
    case FETCH_CO_OPERATION_OLD_REQUEST + _FAILURE:
      return false;

    default:
      return state;
  }
}

export const cooperationOld = combineReducers({ item, isFetching });
